/**
 * Tabla pedidos A3: ocupa el 100% del ancho del contenedor; COMPRA/VENTA mismas
 * proporciones en Estimates y ProduccionSummary.
 */

/** Contenedor: ancho completo, más alto para ver más filas */
export const a3PedidosTableContainerSx = {
  maxHeight: { xs: 480, sm: 620 },
  width: "100%",
  border: (t) => `1px solid ${t.palette.divider}`,
  borderRadius: 2,
};

export const a3PedidosTableFixedSx = {
  tableLayout: "fixed",
  width: "100%",
};

/** Tipografía algo mayor que la “dense” anterior */
export const a3TableDenseSx = {
  "& .MuiTableCell-root": {
    fontSize: "0.875rem",
    py: 1.1,
    px: 1.35,
    verticalAlign: "top",
    lineHeight: 1.5,
  },
};

export const a3PedidosCellClipSx = {
  minWidth: 0,
  overflow: "hidden",
  wordBreak: "break-word",
};

/* ——— Anchos de columna (% del ancho de la tabla) ——— */

/** Lápiz edición (Estimates) */
export const A3_COL_EDIT_WIDTH = "5%";
/** Ref. / artículo */
export const A3_COL_LINK_ESTIMATES_WIDTH = "23%";
/** Presup. / vínculo (resumen; equivale ~ lápiz + ref) */
export const A3_COL_LINK_SUMMARY_WIDTH = "15%";
export const A3_COL_COMPRA_WIDTH = "36%";
export const A3_COL_VENTA_WIDTH = "36%";
